import { render, staticRenderFns } from "./sectionImport.vue?vue&type=template&id=5dd4c8a8&scoped=true&"
import script from "./sectionImport.vue?vue&type=script&lang=js&"
export * from "./sectionImport.vue?vue&type=script&lang=js&"
import style0 from "./sectionImport.vue?vue&type=style&index=0&id=5dd4c8a8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd4c8a8",
  null
  
)

export default component.exports